module.exports = __webpack_public_path__ + "img/lilun.75b4dd08.jpg";